/**
 * Счётчик на значке приложения: в скольких разговорах есть непрочитанное.
 *
 * <p>Веб-уведомления не умеют собираться в стопку с общей шапкой, как на телефоне, — это
 * ограничение площадки, а не выбор. Значок остаётся единственным местом, где видно общее число,
 * не открывая вкладку.
 *
 * <p>Считаем по самой шторке, а не по своему счётчику: она и есть источник истины о том, что
 * человек ещё не разобрал, и переживает перезапуск браузера. Каждое уведомление помечено меткой
 * разговора, поэтому число разных меток — это число разговоров, а не сообщений.
 */
export const updateAppBadge = async (registration?: ServiceWorkerRegistration | null) => {
  if (typeof navigator === 'undefined' || !('setAppBadge' in navigator)) {
    return;
  }

  try {
    const target = registration ?? (await navigator.serviceWorker?.getRegistration());
    if (!target) {
      return;
    }
    const shown = await target.getNotifications();
    const threads = new Set(shown.map((notification) => notification.tag).filter(Boolean));

    if (threads.size > 0) {
      await navigator.setAppBadge(threads.size);
    } else if ('clearAppBadge' in navigator) {
      await navigator.clearAppBadge();
    }
  } catch {
    // Значок — украшение: браузер вправе его не поддерживать или запретить, и это не повод
    // мешать чему-либо ещё.
  }
};
